module.exports = __webpack_public_path__ + "img/counselors-1.33dd103b.jpg";